import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b65ecef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Progress" }
const _hoisted_2 = { class: "card mb-3" }
const _hoisted_3 = { class: "card-header bg-light" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Classgroups")
], -1))
const _hoisted_6 = { class: "col" }
const _hoisted_7 = ["data-list"]
const _hoisted_8 = { class: "table-responsive scrollbar" }
const _hoisted_9 = { class: "table table-sm fs--1 mb-0 table-hover" }
const _hoisted_10 = { class: "text-900" }
const _hoisted_11 = { class: "text-props fs-sm--1" }
const _hoisted_12 = {
  scope: "col",
  class: "pr-1 align-middle sort d-flex",
  "data-sort": "code"
}
const _hoisted_13 = { class: "align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Group Code", -1))
const _hoisted_15 = { class: "nav-link-icon mx-1" }
const _hoisted_16 = {
  ref: "classGroupCodeInfoTooltip",
  class: "fas fa-info-circle icon-info",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: "The group code is for a Teacher to give to students to put in their app so that they can do those exercises assigned from the Teacher. It is also used for billing and subscription payments."
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-middle sort w-25",
  "data-sort": "name"
}, " Group Name ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-middle w-25",
  "data-sort": "language"
}, " Language ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-middle",
  "data-sort": "studentCount"
}, " Number of Students ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_21 = { class: "list" }
const _hoisted_22 = ["textContent", "onClick"]
const _hoisted_23 = ["textContent", "onClick"]
const _hoisted_24 = ["textContent", "onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["textContent"]
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = ["textContent", "onClick"]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-light d-flex justify-content-center py-2\" data-v-0b65ecef><button class=\"btn btn-sm btn-falcon-default me-1\" type=\"button\" title=\"Previous\" data-list-pagination=\"prev\" data-v-0b65ecef><span class=\"fas fa-chevron-left\" data-v-0b65ecef></span></button><ul class=\"pagination mb-0\" data-v-0b65ecef></ul><button class=\"btn btn-sm btn-falcon-default ms-1\" type=\"button\" title=\"Next\" data-list-pagination=\"next\" data-v-0b65ecef><span class=\"fas fa-chevron-right\" data-v-0b65ecef></span></button></div>", 1)
const _hoisted_30 = { class: "row g-3 mb-3 excercises classgroup" }
const _hoisted_31 = {
  key: 0,
  class: "col-lg-2"
}
const _hoisted_32 = { class: "card" }
const _hoisted_33 = { class: "card-header bg-light" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Assignments List")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row flex-between-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "aling-middle align-items-center fs--1" }, " Add more than one to the same deadline and they will be all included together for that deadline date. ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_37 = { class: "row flex-between-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_SearchExercises = _resolveComponent("SearchExercises")!
  const _component_DataTableExercises = _resolveComponent("DataTableExercises")!

  return (_ctx.languagePair)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "btn btn-primary me-1 mb-1 btn-table-header float-end",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createNewGroup && _ctx.createNewGroup(...args)))
                  }, " New + ")
                ])
              ])
            ]),
            (_ctx.classgroups.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "card-body px-0 py-0",
                  id: "classgroups-data-table",
                  "data-list": JSON.stringify(_ctx.dataListOptions)
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                      _createElementVNode("thead", _hoisted_10, [
                        _createElementVNode("tr", _hoisted_11, [
                          _createElementVNode("th", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _hoisted_14,
                              _createElementVNode("span", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, null, 512)
                              ])
                            ])
                          ]),
                          _hoisted_17,
                          _hoisted_18,
                          _hoisted_19,
                          _hoisted_20
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classgroups, (classGroup) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "btn-reveal-trigger",
                            key: classGroup.id
                          }, [
                            _createElementVNode("td", {
                              class: "code align-middle",
                              textContent: _toDisplayString(classGroup.code),
                              onClick: ($event: any) => (_ctx.goToClassgroupExercises(classGroup.id))
                            }, null, 8, _hoisted_22),
                            _createElementVNode("td", {
                              class: "name align-middle w-25",
                              textContent: _toDisplayString(classGroup.name),
                              onClick: ($event: any) => (_ctx.goToClassgroupExercises(classGroup.id))
                            }, null, 8, _hoisted_23),
                            _createElementVNode("td", {
                              class: "align-middle language w-25",
                              textContent: _toDisplayString(classGroup.languageMapping.name),
                              onClick: ($event: any) => (_ctx.goToClassgroupExercises(classGroup.id))
                            }, null, 8, _hoisted_24),
                            _createElementVNode("td", {
                              class: "align-middle studentCount",
                              onClick: ($event: any) => (_ctx.goToClassgroupExercises(classGroup.id))
                            }, [
                              _createElementVNode("label", {
                                class: "ms-5",
                                textContent: _toDisplayString(classGroup.studentCount)
                              }, null, 8, _hoisted_26)
                            ], 8, _hoisted_25),
                            _createElementVNode("td", _hoisted_27, [
                              _createVNode(_component_Dropdown, {
                                id: `classgoups-dropdown-${classGroup.id}`
                              }, {
                                options: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: {
                            name: 'ClassgroupDetails',
                            params: { classgroupId: classGroup.id },
                          },
                                    class: "dropdown-item",
                                    textContent: _toDisplayString('Details')
                                  }, null, 8, ["to", "textContent"]),
                                  _createElementVNode("button", {
                                    class: "dropdown-item text-danger",
                                    textContent: _toDisplayString('Delete'),
                                    onClick: ($event: any) => (_ctx.deleteClassgroup(classGroup))
                                  }, null, 8, _hoisted_28)
                                ]),
                                _: 2
                              }, 1032, ["id"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _hoisted_29
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_ctx.showVerticalFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(_component_SearchExercises, {
                  vertical: "",
                  "language-pairs": _ctx.languagePairs,
                  onFilter: _ctx.filterExercises
                }, null, 8, ["language-pairs", "onFilter"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({
          'col-lg-10': _ctx.showVerticalFilter,
          'col-lg': !_ctx.showVerticalFilter,
        })
          }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                (!_ctx.showVerticalFilter)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_SearchExercises, {
                          horizontal: "",
                          "language-pairs": _ctx.languagePairs,
                          onFilter: _ctx.filterExercises
                        }, null, 8, ["language-pairs", "onFilter"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.exercises.length > 0)
                ? (_openBlock(), _createBlock(_component_DataTableExercises, {
                    key: 0,
                    "class-groups": _ctx.classgroups,
                    "language-pair": _ctx.languagePair.pair,
                    exercises: _ctx.exercises,
                    pagination: _ctx.exercisesPagination,
                    onChangePage: _ctx.getExercises
                  }, null, 8, ["class-groups", "language-pair", "exercises", "pagination", "onChangePage"]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ])
      ], 64))
    : _createCommentVNode("", true)
}